import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import StatusBadge from 'app/componentV4/Status/Badge'
import {
  ERROR,
  NORMAL,
  DISTRESS,
  UNAVAILABLE,
} from 'app/constants/statusColors'

import { POLL_END, POLL_OPEN } from 'app/constants/messageDetail'

const Badges = (props) => {
  const {
    date,
    poll = {},
    isPoll = false,
    isExpiration = false,
    isCanceleScheduled = false,
  } = props
  const { formatMessage } = useIntl()

  const displayExpirationDateTime = () => {
    return (
      <>
        {moment().isBefore(date) ? (
          <StatusBadge
            type={DISTRESS}
            label={formatMessage({
              id: 'text.expiring',
            })}
          />
        ) : (
          <StatusBadge
            type={UNAVAILABLE}
            label={formatMessage({
              id: 'text.expired',
            })}
          />
        )}
      </>
    )
  }

  const displayCanceleScheduledDateTime = () => {
    return (
      <StatusBadge
        type={ERROR}
        label={formatMessage({
          id: 'text.descheduled',
        })}
      />
    )
  }

  const displayPollBadge = (type) => {
    switch (type) {
      case POLL_OPEN:
        return (
          <StatusBadge
            type={NORMAL}
            label={formatMessage({
              id: 'label.open',
            })}
          />
        )
      case POLL_END:
        return (
          <StatusBadge
            type={UNAVAILABLE}
            label={formatMessage({
              id: 'text.status.ended',
            })}
          />
        )

      default:
        return
    }
  }

  return (
    <>
      {isExpiration ? displayExpirationDateTime() : null}
      {isCanceleScheduled ? displayCanceleScheduledDateTime() : null}
      {isPoll ? displayPollBadge(poll?.status) : null}
    </>
  )
}

Badges.propTypes = {
  date: PropTypes.string,
  poll: PropTypes.shape({
    id: PropTypes.number,
    status: PropTypes.string,
  }),
  isPoll: PropTypes.bool,
  isExpiration: PropTypes.bool,
  isCanceleScheduled: PropTypes.bool,
}

export default Badges
